import React, { useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import {
  YMaps,
  Map,
  ZoomControl,
  FullscreenControl,
  GeolocationControl,
  withYMaps
} from 'react-yandex-maps';
import { quarterConverter } from '../../helpers';
import styles from '../../styles/modules/building/BuildingMap.module.scss';

const TemplateProvider = withYMaps(({ children, template }) => children({ template }), true, [
  'templateLayoutFactory'
]);

const BuildingInformation = ({ buildings }) => {
  const [ymaps, setYmaps] = useState();
  const [manager, setManager] = useState();

  const mapEl = useRef();

  const YMapsInit = (y) => {
    setYmaps(y);

    const objectManager = new y.ObjectManager({
      clusterize: false,
      clusterHasBalloon: false,
      geoObjectOpenBalloonOnClick: false
    });

    objectManager.objects.events.add('click', (e) => {
      const cc = objectManager.objects.getById(e.get('objectId'));

      mapEl.current.panTo(cc.geometry.coordinates).then(() => {
        mapEl.current.setZoom(17, { duration: 300 });
      });
    });

    const points = [];
    for (let i = 0; i < buildings.length; i++) {
      points.push({
        type: 'Feature',
        id: i + 1,
        properties: {
          buildingSection: buildings[i]['building-section'],
          readyQuarter: quarterConverter(buildings[i]['ready-quarter']),
          builtYear: buildings[i]['built-year']
        },
        geometry: {
          type: 'Point',
          coordinates: [buildings[i].location.latitude, buildings[i].location.longitude]
        }
      });
    }

    objectManager.add(points);
    mapEl.current.geoObjects.add(objectManager);

    setManager(objectManager);

    mapEl.current.setBounds(objectManager.getBounds(), { checkZoomRange: true, zoomMargin: 60 });

    objectManager.objects.options.set({
      iconLayout: y.templateLayoutFactory.createClass(
        `<div class="point">${
          mapEl.current.getZoom() > 16
            ? '<div class="information">{{ properties.buildingSection }}<div class="description">{{ properties.readyQuarter }} квартал {{ properties.builtYear }}</div></div>'
            : ''
        }</div>`
      ),
      iconShape: {
        type: 'Circle',
        coordinates: [6, 6],
        radius: 6
      },
      iconOffset: [-6, -6],
      hasBalloon: false,
      zIndex: 6
    });
  };

  return (
    <section className="block">
      <div className="fixed">
        <h3>Расположение</h3>
        <div className={styles.mapContainer}>
          <YMaps query={{ apikey: process.env.NEXT_PUBLIC_YANDEX_KEY }}>
            <TemplateProvider>
              {() => (
                <Map
                  modules={['ObjectManager', 'util.bounds']}
                  style={{ width: '100%', height: '100%' }}
                  defaultState={{
                    center: [47.233815, 39.717624],
                    zoom: 17,
                    controls: [],
                    behaviors: [!isMobile && 'drag', 'dblClickZoom', 'multiTouch']
                  }}
                  defaultOptions={{
                    maxZoom: 20,
                    autoFitToViewport: 'always',
                    yandexMapDisablePoiInteractivity: true,
                    suppressObsoleteBrowserNotifier: true,
                    suppressMapOpenBlock: true
                  }}
                  onBoundsChange={(e) => {
                    if (e.get('newZoom') !== e.get('oldZoom') && manager) {
                      manager.objects.options.set({
                        iconLayout: ymaps.templateLayoutFactory.createClass(
                          `<div class="point">${
                            e.get('newZoom') > 16
                              ? '<div class="point"><div class="information">{{ properties.buildingSection }}<div class="description">{{ properties.readyQuarter }} квартал {{ properties.builtYear }}</div></div></div>'
                              : ''
                          }</div>`
                        )
                      });
                    }
                  }}
                  onLoad={(y) => YMapsInit(y)}
                  instanceRef={(ref) => {
                    if (ref) mapEl.current = ref;
                  }}
                >
                  {!isMobile && (
                    <ZoomControl
                      options={{
                        position: { right: '12px', top: '123px' },
                        size: 'small'
                      }}
                    />
                  )}
                  <FullscreenControl
                    options={{
                      position: { right: '12px', top: '12px' }
                    }}
                  />
                  <GeolocationControl
                    options={{
                      position: { left: '12px', top: '12px' }
                    }}
                  />
                </Map>
              )}
            </TemplateProvider>
          </YMaps>
        </div>
      </div>
    </section>
  );
};

export default BuildingInformation;
